<template>
  <div class="planning-technicien px-1" style="margin-top: 1.5vh">
    <div class="">
      <div style="font-size: 20px">
      <v-dialog v-model="isModalChangeEventStateOpen" max-width="480" persistent>
        <v-card rounded="lg">
          <v-card-title class="pa-4 d-flex align-center gap-2" style="background:#FFF3E0">
            <v-icon color="orange-darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>
            <span style="font-size:16px;font-weight:700">Confirmation de modification</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-4" style="font-size:15px">
            L'intervention <strong>{{ modaleChangeEventState.num }}</strong> a déjà été envoyée au(x) technicien(s). Êtes-vous sûr de vouloir la modifier ?
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="isModalChangeEventStateOpen = false">Non</v-btn>
            <v-btn color="success" variant="flat" style="color:white"
              @click="(isModalChangeEventStateOpen = false), verifEditEventFromModal({ e: modaleChangeEventState.e, Techniciens_Nom: modaleChangeEventState.calendarTech })">
              <v-icon class="mr-1" size="18">mdi-check</v-icon>Oui, modifier
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </div>
      <v-dialog v-model="isDateSettingOpen" width="99%" max-width="520">
        <v-card rounded="lg">
          <!-- Header -->
          <v-card-title class="pa-4 d-flex align-center" style="background:#3F51B5">
            <v-icon color="white" class="mr-2">mdi-calendar-cog</v-icon>
            <span style="font-size:16px;font-weight:700;color:white">Affichage du planning</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="text" density="compact" color="white" @click="isDateSettingOpen = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>

          <!-- Body -->
          <v-card-text class="pa-5">
            <v-row>
              <!-- Jours à afficher -->
              <v-col cols="12" sm="6">
                <div class="text-caption text-medium-emphasis mb-1 d-flex align-center">
                  <v-icon size="14" class="mr-1">mdi-calendar-week</v-icon>Jours à afficher
                </div>
                <v-select
                  v-model="selectedNbrDays"
                  :items="nbrDaysdurationListe"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :item-title="(elem) => elem + ' jours'"
                  :item-value="(elem) => elem"
                ></v-select>
              </v-col>

              <!-- Slot horaire -->
              <v-col cols="12" sm="6">
                <div class="text-caption text-medium-emphasis mb-1 d-flex align-center">
                  <v-icon size="14" class="mr-1">mdi-clock-outline</v-icon>Slot horaire
                </div>
                <v-select
                  v-model="selectedslotduration"
                  :items="slotdurationListe"
                  variant="outlined"
                  density="compact"
                  hide-details
                ></v-select>
              </v-col>

              <!-- Heure de début -->
              <v-col cols="12" sm="6">
                <div class="text-caption text-medium-emphasis mb-1 d-flex align-center">
                  <v-icon size="14" class="mr-1">mdi-weather-sunset-up</v-icon>Heure de début
                </div>
                <v-select
                  v-model="selectedStartTime"
                  :items="startPlanningTime"
                  variant="outlined"
                  density="compact"
                  hide-details
                ></v-select>
              </v-col>

              <!-- Heure de fin -->
              <v-col cols="12" sm="6">
                <div class="text-caption text-medium-emphasis mb-1 d-flex align-center">
                  <v-icon size="14" class="mr-1">mdi-weather-sunset-down</v-icon>Heure de fin
                </div>
                <v-select
                  v-model="selectedEndTime"
                  :items="endPlanningTime"
                  variant="outlined"
                  density="compact"
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="#3F51B5" variant="flat" style="color:white" @click="isDateSettingOpen = false">
              <v-icon class="mr-1" size="18">mdi-check</v-icon>Appliquer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isModalOptionOpen" width="99%" max-width="800">
        <v-card>
          <modal-options
            :isRoot="isRoot"
            :technicienList="technicienList"
            :commentaireListe="commentaireListe"
            :setCommentaires="setCommentaires"
            @close="isModalOptionOpen = false"
          ></modal-options>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isModalSettingsOpen" persistent>
        <modal-settings
          :eventColorByType="eventColorByIdFiltered"
          :daysToHide="daysToHide"
          @closeSettingsModal="closeSettingsModal"
        ></modal-settings>
      </v-dialog>
      <v-dialog v-model="isModalSelectionTechnicienOpen" width="99%" max-width="800">
        <modal-selection-technicien
          :isRoot="isRoot"
          :technicienList="technicienList"
          :technicienListAvailable="technicienListAvailable"
          :setTechnicienAvailable="setTechnicienAvailable"
          :addOrRmvTechnicien="addOrRmvTechnicien"
          :updateTechToShow="updateTechToShow"
          :setSelectedTechniciens="setSelectedTechniciens"
          :selectedTechniciens="selectedTechniciens"
          @close="isModalSelectionTechnicienOpen = false"
          @save="editSelectionnedTechnicien($event)"
        ></modal-selection-technicien>
      </v-dialog>
      <v-dialog v-model="isModalTechnicienOpen">
        <modal-technicien
          :data="modaleTechnicienData"
          :technicienList="technicienList"
          :planningSettings="planningSettings"
          @close="closeModalEvent"
          @save="verifEditEventFromModal($event)"
        >
        </modal-technicien>
      </v-dialog>
      <v-dialog
        v-model="isModalEventOpen"
        width="99%"
        :max-width="selectedEvent['CLD_NUM_CONTRAT'] ? 1500 : 800"
      >
        <modal-event
          v-if="selectedEvent['N° RAP COMP']"
          :event-data="selectedEvent"
          :optionsPlanning="optionsPlanning"
          :eventColorById="eventColorById"
          :eventColorByIdFiltered="eventColorByIdFiltered"
          :isRoot="isRoot"
          @close="closeModalEvent"
          @save="editEventFromModal"
        ></modal-event>
        <modal-contrat-state
          v-else-if="selectedEvent['CLD_NUM_CONTRAT']"
          :closeModal="
            function () {
              isModalEventOpen = false;
            }
          "
          :deleteDriver="cancelDriver"
          :eventsData="
            removeDoublon(
              contratListe.filter(
                (val) => val.CLD_NUM_CONTRAT == selectedEvent.CLD_NUM_CONTRAT
              ),
              'CLD_ID_CONTRAT_LOC_DATA'
            )
          "
        ></modal-contrat-state>
      </v-dialog>
      <div style="" class="">
        <div
          id=""
          :style="{ height: windowSize.height * (0.6 - selectedSize) + 'px' }"
          class="hideDot"
          v-if="isDataLoaded"
          style="position: relative"
        >
          <full-calendar
            class="hideDot"
            ref="calendarTech"
            :options="calendarOptions"
            :style="{ height: windowSize.height * (0.6 - selectedSize) + 'px' }"
          />
          <div
            v-if="isDataLoaded"
            :style="{
              bottom: fullView
                ? ''
                : parseInt(calendarOptions.height.replace('vh', '')) - 22 + 'vh',
            }"
            style="position: absolute; bottom: -10px; right: 5px; z-index: 1; pointer-events: none"
          >
            <v-hover
              v-if="showLegende == true || fullView"
              v-slot="{ props }"
              open-delay="0"
            >
              <div
                ref="legendEl"
                @click="showLegende = false"
                v-bind="props"
                :style="{ opacity: legendHidden ? 0 : 1, transition: 'opacity .15s ease' }"
                style="
                  background-color: #e0e0e0;
                  border-style: none;
                  padding: 5px;
                  margin-left: 10px;
                  border-radius: 10px;
                  box-shadow: 1px 1px 10px 2px grey;
                "
              >
                <button
                  v-for="elem in optionsPlanning.find(
                    (val2) => val2.key == 'use_accen_tablette'
                  ).value == 1
                    ? Object.values(eventColorByIdFiltered)
                    : Object.values(eventColorByIdFiltered).filter(
                        (val) =>
                          optionsPlanning.find((val2) => val2.key == 'use_accen_tablette')
                            .value == 0 && val.key != '120'
                      )"
                  :key="elem.key"
                  :style="{
                    'background-color': eventColorByIdFiltered[elem.key].color,
                  }"
                  style="
                    font-size: 15px;
                    margin: 5px;
                    border: solid 1px grey;
                    padding: 5px;
                    border-style: none;
                    border-radius: 5px;
                    color: black;
                  "
                >
                  <v-chip
                    style="
                      background-color: rgb(0, 0, 0, 0.5);
                      color: white;
                      cursor: pointer;
                    "
                  >
                    {{ elem.label }}
                  </v-chip>
                </button>
              </div>
            </v-hover>
          </div>

          <!-- :style="{ height: windowSize.height - 225 + 'px' }" /> -->
        </div>
        <div v-else align="center" style="padding-top: 20%">
          <v-progress-circular size="120" indeterminate color="black"
            >Chargement</v-progress-circular
          >
        </div>
      </div>
      <v-col cols="12" class="pb-0">
        <!-- <v-row justify="center" align="center" :style="{ height: ((windowSize.height * 0.043) * 5) + 'px' }"> -->
        <v-row
          align="center"
          style=""
          :style="{
            'background-color': isDataLoaded ? '#c8e6c9' : '',
            height: windowSize.height * (0.31 + selectedSize) + 'px',
          }"
        >
          <v-col
            v-if="isDataLoaded"
            cols="3"
            md="2"
            class="pb-0"
            style="background-color: #c8e6c9; border-right: solid 1px white"
          >
            <v-row justify="center" align="center">
              <v-col cols="12" class="pa-1 pb-0">
                <v-tooltip text="Ajuster la hauteur" location="top">
                  <template v-slot:activator="{ props }">
                    <v-slider
                      v-bind="props"
                      v-model="selectedSize"
                      :max="0.25"
                      :min="-0.18"
                      :step="0.01"
                      color="#7986CB"
                      hide-details
                    ></v-slider>
                  </template>
                </v-tooltip>
              </v-col>
              <v-col cols="6" class="pa-1">
                <v-tooltip text="Rafraîchir" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" style="width:100%" density="compact" @click="refreshData">
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </v-col>
              <v-col cols="6" class="pa-1">
                <v-tooltip text="Paramètres d'affichage" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" style="width:100%" density="compact" @click="isDateSettingOpen = true">
                      <v-icon>mdi-calendar-month-outline</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </v-col>
              <v-col cols="6" class="pa-1">
                <v-tooltip text="Commentaires" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" :disabled="!isRoot" density="compact" style="width:100%" @click="isModalOptionOpen = true">
                      <v-icon>mdi-comment-text-outline</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </v-col>
              <v-col cols="6" class="pa-1">
                <v-tooltip text="Gestion techniciens" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" :disabled="!isRoot" density="compact" style="width:100%" @click="isModalSelectionTechnicienOpen = true">
                      <v-icon>mdi-account-cog-outline</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </v-col>
              <!-- <v-col cols="12" class="pa-1">
                <v-text-field
                  placeholder="Recherche..."
                  v-model="filter"
                  hide-details
                  density="compact"
                  variant="solo"
                  style="background-color: white"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" class="pa-1" v-if="agencyList && agencyList.length > 1">
                <v-select
                  clearable
                  class=""
                  hide-details
                  placeholder="Agence"
                  density="compact"
                  v-model="selectedAgency"
                  variant="solo"
                  :items="agencyList"
                  item-value="id"
                  item-title="text"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col>
            {{
              contratListeToShow.map(
                (val) => val.CLD_NUM_CONTRAT + " - " + val.CLD_MATRICULE
              )
            }}
          </v-col> -->
          <!-- {{ getAllContratToShow }} -->
          <v-col
            :style="{
              visibility: isDataLoaded ? '' : 'hidden',
              height: windowSize.height * (0.31 + selectedSize) + 'px',
            }"
            style="
              border-radius: 0px;
              width: 100%;
              overflow-y: auto;
              overflow-x: auto;
              white-space: nowrap;
              background-color: #c8e6c9;
            "
            class="pb-0"
            id="external-events"
          >
            <!-- return { livRemoveDoublon, retRemoveDoublon }; -->

            <v-row>
              <!-- v-for="(elem, idx) in [
                  ...new Map(
                    contratListeToShow.map((item) => [item.CLD_NUM_CONTRAT, item])
                  ).values(),
                ]" -->

              <v-col
                v-for="(elem, idx) in getAllContratToShow.livRemoveDoublon"
                :key="idx"
                cols="auto"
                class="pa-1"
              >
                <v-card
                  @mouseover="setSelectedEvent(elem)"
                  class="mr-1 fc-event"
                  :style="{
                    borderRadius: '6px',
                    padding: '0',
                    display: 'inline-block',
                    border: 'solid 2px rgba(255,82,82,0.7)',
                    backgroundColor: eventColorById['contrat-'].color,
                    minWidth: '140px',
                    cursor: 'move',
                    overflow: 'hidden'
                  }"
                >
                  <div style="background:rgba(0,0,0,0.2); padding:3px 7px; display:flex; align-items:center; gap:4px">
                    <v-icon size="12" color="white">mdi-truck-delivery-outline</v-icon>
                    <span style="color:white; font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:0.5px">Liv. Départ</span>
                  </div>
                  <div style="padding:5px 7px; color:white">
                    <div style="font-weight:700; font-size:12px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:180px">
                      {{ elem.CLD_CLIENT_RAISON_SOCIALE }}
                    </div>
                    <div style="font-size:11px; color:rgba(255,255,255,0.85); margin-top:2px">
                      <v-icon size="11" color="rgba(255,255,255,0.7)">mdi-calendar</v-icon>
                      {{ formatDate(elem.CLD_DATE_LIVRAISON_DEPART, "DD/MM/YYYY") }}
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col
                v-for="(elem, idx) in getAllContratToShow.retRemoveDoublon"
                :key="idx"
                cols="auto"
                class="pa-1"
              >
                <v-card
                  @mouseover="setSelectedEvent(elem)"
                  class="mr-1 fc-event"
                  :style="{
                    borderRadius: '6px',
                    padding: '0',
                    display: 'inline-block',
                    border: 'solid 2px rgba(255,82,82,0.7)',
                    backgroundColor: eventColorById['contrat-Sortie'].color,
                    minWidth: '140px',
                    cursor: 'move',
                    overflow: 'hidden'
                  }"
                >
                  <div style="background:rgba(0,0,0,0.2); padding:3px 7px; display:flex; align-items:center; gap:4px">
                    <v-icon size="12" color="white">mdi-truck-outline</v-icon>
                    <span style="color:white; font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:0.5px">Liv. Retour</span>
                  </div>
                  <div style="padding:5px 7px; color:white">
                    <div style="font-weight:700; font-size:12px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:180px">
                      {{ elem.CLD_CLIENT_RAISON_SOCIALE }}
                    </div>
                    <div style="font-size:11px; color:rgba(255,255,255,0.85); margin-top:2px">
                      <v-icon size="11" color="rgba(255,255,255,0.7)">mdi-calendar</v-icon>
                      {{ formatDate(elem.CLD_DATE_LIVRAISON_RETOUR, "DD/MM/YYYY") }}
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col
                v-for="(elem, idx) in getEventsListFiltered"
                :key="idx"
                cols="auto"
                class="pa-1"
              >
                <v-card
                  @mouseover="setSelectedEvent(elem)"
                  class="mr-1 fc-event"
                  :style="{
                    borderRadius: '6px',
                    padding: '0',
                    display: 'inline-block',
                    border: elem.id == selectedEvent.id ? 'solid 2px #FF1744' : 'solid 2px rgba(255,255,255,0.2)',
                    backgroundColor: eventColorById[elem.Statut].color,
                    minWidth: '170px',
                    maxWidth: '220px',
                    cursor: 'move',
                    overflow: 'hidden',
                    verticalAlign: 'top'
                  }"
                >
                  <!-- Header -->
                  <div style="background:rgba(0,0,0,0.2); padding:3px 7px; display:flex; align-items:center; justify-content:space-between">
                    <span class="fc-event-main" style="color:white; font-weight:700; font-size:12px; letter-spacing:0.3px">{{ elem["N° RAP COMP"] }}</span>
                    <v-btn
                      density="compact"
                      :disabled="!isRoot"
                      variant="text"
                      color="white"
                      size="x-small"
                      icon
                      @click.stop="removeEventFromList(elem)"
                      style="opacity:0.8"
                    >
                      <v-icon size="14">mdi-close</v-icon>
                    </v-btn>
                  </div>
                  <!-- Body -->
                  <v-menu open-on-hover open-delay="0">
                    <template v-slot:activator="{ props }">
                      <div v-bind="props" style="padding:5px 7px; color:white; cursor:move">
                        <div class="fc-event-main" style="font-weight:600; font-size:12px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:200px; color:#e6ee9c">
                          {{ elem["societeliv"] }}
                        </div>
                        <div style="font-size:11px; color:rgba(255,255,255,0.8); margin-top:1px">
                          ({{ elem["Technicien"].filter(v => v).join(" - ") }})
                        </div>
                        <div class="fc-event-main" style="font-size:11px; color:rgba(255,255,255,0.9); margin-top:3px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:200px">
                          {{ elem["Theme devis"] }}
                        </div>
                      </div>
                    </template>
                    <v-card class="pa-3" min-width="180">
                      <div style="font-size:13px; line-height:1.6">
                        <div style="font-weight:600">{{ elem["societeliv"] }}</div>
                        <div style="color:grey">{{ elem["villeliv"] }}</div>
                        <div style="color:grey">{{ elem["adliv"] }}</div>
                      </div>
                    </v-card>
                  </v-menu>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-snackbar
        :model-value="errorMessage && errorMessage.length > 0"
        color="#D50000"
        location="bottom center"
        :timeout="5000"
        rounded="lg"
        multi-line
        elevation="4"
      >
        <div v-for="elem in errorMessage" :key="elem" style="font-size:14px">{{ elem }}</div>
      </v-snackbar>
    </div>
    <v-btn
      color="#5C6BC0"
      :style="{
        top: parseInt(calendarOptions.height.replace('vh', '')) - 4 + 'vh',
      }"
      style="color: white; margin-left: 10px; position: absolute; right: 7px"
      v-if="fullView == false"
      @click="showLegende = !showLegende"
    >
      {{ showLegende ? 'Masquer légende' : 'Légende' }}
    </v-btn>
  </div>
</template>

<script>
import "@fullcalendar/core/vdom";
import FullCalendar from "@fullcalendar/vue3";
import planningTechnicien from "../core/index";

import ModalEvent from "./modal-event.vue";
import ModalContratState from "../../../components/modal-contrat-state.vue";

import ModalTechnicien from "./modal-technicien.vue";
import ModalSelectionTechnicien from "./modal-selection-technicien.vue";
import ModalOptions from "./modal-options.vue";
import ModalSettings from "@/components/modal-planning-settings.vue";

import calendarData from "../hooks/index";
import { ref } from "@vue/reactivity";
import { computed, watch } from "@vue/runtime-core";

import moment from "moment";
import engine from "../core/index";

export default {
  props: {
    windowSize: {},
  },
  components: {
    FullCalendar,
    ModalEvent,
    ModalTechnicien,
    ModalSelectionTechnicien,
    ModalSettings,
    ModalOptions,
    ModalContratState,
  },
  setup(props) {
    const showOnlyState2 = ref(false);
    const selectedSize = ref(-0.1);
    const modaleTechnicienData = ref({});
    const modaleChangeEventState = ref({});
    const isDateSettingOpen = ref(false);
    const isModalTechnicienOpen = ref(false);
    const isModalOptionOpen = ref(false);
    const isModalChangeEventStateOpen = ref(false);
    const isModalSelectionTechnicienOpen = ref(false);
    const connectionError = ref(false);
    const filter = ref("");
    const userMail = ref(undefined);
    const userPassword = ref(undefined);
    const fullView = ref(true);
    const showLegende = ref(false);

    const handleEventReceive = function (e) {
      if (isRoot.value) {
        if (
          isGoodEventSelected(e, selectedEvent) &&
          isEditableEvent(e, selectedEvent.value)
        ) {
          editEventFromCalendar(e, undefined, true, true);
        }
      } else {
        showErrorMessage("ERREUR : Cette action nécessite un compte administrateur");
      }
      e.revert();
    };
    const handleEventDragTime = function (e) {
      if (isRoot.value) {
        let event = e.event.extendedProps.event;
        selectedEvent.value = event;
        if (isEditableEvent(e, selectedEvent.value))
          editEventFromCalendar(e, undefined, false, false);
      } else {
        showErrorMessage("ERREUR : Cette action nécessite un compte administrateur");
        e.revert();
      }
    };
    const handleEventClick = function (e) {
      if (e.event.display != "background") {
        let event = e.event.extendedProps.event;
        selectedEvent.value = event;
        isModalEventOpen.value = true;
      } else {
        if (e.event.extendedProps.TYPE != undefined)
          showErrorMessage(
            "INDISPONIBILITÉ : " + e.event._def.resourceIds,
            moment(e.event.start).lang("fr").format("LLLL") +
              " / " +
              moment(e.event.end).lang("fr").format("LLLL")
          );
      }
    };
    const handleEventDrop = function (e) {
      if (isRoot.value) {
        let event = e.event.extendedProps.event;
        selectedEvent.value = event;

        if (isEditableEvent(e, selectedEvent.value))
          editEventFromCalendar(e, undefined, false, false);
      } else {
        showErrorMessage("ERREUR : Cette action nécessite un compte administrateur");
        e.revert();
      }
    };
    const isGoodEventSelected = function (eventData, selectedEvent) {
      let eventTitle = eventData.event._def.title;

      console.log("isGoodEventSelected");
      console.log("eventData", eventData);
      console.log("selectedEvent", selectedEvent.value);

      if (
        eventTitle.includes(selectedEvent.value["N° RAP COMP"]) &&
        eventTitle.includes(selectedEvent.value["Technicien"])
      )
        return true;
      else if (
        eventTitle.includes(selectedEvent.value["CLD_NUM_CONTRAT"]) ||
        eventTitle.includes(selectedEvent.value["CLD_CLIENT_RAISON_SOCIALE"])
      )
        return true;
      else {
        showErrorMessage("ERREUR : " + selectedEvent.value["N° RAP COMP"]);
        return false;
      }
    };

    const isEditableEvent = function (e, event) {
      if (event.Statut == undefined) {
        return true;
      } else {
        if (event.Statut != 140) {
          if (event.Technicien.join("-") != e.event._def.resourceIds.join("-")) {
            if (isTechnicienAvailable(e, event, e.event._def.resourceIds)) {
              isModalTechnicienOpen.value = true;
              modaleTechnicienData.value = {
                e: e,
                num: event["N° RAP COMP"],
                eventId: event.id,
                eventTech: event.Technicien,
                calendarTech: e.event._def.resourceIds,
                technicienListAvailable: technicienListAvailable,
              };
            }
            e.revert();
            return false;
          }
          if (isTechnicienAvailable(e, event, event.Technicien)) {
            if (event.Statut == 120 || event.Statut == 130) {
              isModalChangeEventStateOpen.value = true;
              modaleChangeEventState.value = {
                e: e,
                num: event["N° RAP COMP"],
                calendarTech: e.event._def.resourceIds,
              };
              e.revert();
              return false;
            }
            return true;
          }
          return false;
        } else {
          e.revert();
          showErrorMessage(
            "ERREUR : Intervention " +
              selectedEvent.value["N° RAP COMP"] +
              " est terminé n'est donc plus modifiable."
          );
          return false;
        }
      }
    };

    const removeEventFromList = function (item) {
      editEventFromModal({ id: item.id, Statut: "99", Debut: "", Fin: "" });
    };

    const setSelectedTechniciens = function () {
      if (selectedTechniciens.value.length === technicienList.value.length) {
        selectedTechniciens.value = [];
      } else {
        selectedTechniciens.value = technicienList.value.map((val) => val.id);
      }
    };

    const addOrRmvTechnicien = function (technicienName) {
      if (selectedTechniciens.value.includes(technicienName)) {
        let index = selectedTechniciens.value.indexOf(technicienName);
        selectedTechniciens.value.splice(index, 1);
      } else {
        selectedTechniciens.value.push(technicienName);
      }
    };

    const closeModalEvent = function () {
      isModalEventOpen.value = false;
      isModalTechnicienOpen.value = false;
    };

    const updateTechToShow = function () {
      let token = localStorage.getItem("userToken");
      planningTechnicien.setTechToShow(
        token,
        selectedTechniciens.value.join(","),
        function () {}
      );
    };

    const getTechToShow = function () {
      planningTechnicien.getTechToShow(
        userMail.value,
        userPassword.value,
        function (data) {
          if (data.code == 0) {
            if (data.data == "") {
              selectedTechniciens.value = technicienList.value.map((val) => val.title);
            } else selectedTechniciens.value = data.data.split(",");
          }
        }
      );
    };

    const verifEditEventFromModal = function (eventEdited) {
      this.editEventFromCalendar(eventEdited.e, eventEdited.Techniciens_Nom, true, false);
      isModalTechnicienOpen.value = false;
      isModalEventOpen.value = false;
    };

    const editEventFromModal = function (eventEdited) {
      planningTechnicien.set_event(eventEdited.id, eventEdited, function (data) {
        if (data.code == 0) {
          initEvents();
        }
      });
      isModalTechnicienOpen.value = false;
      isModalEventOpen.value = false;
    };

    const setAgency = function (agencyId) {
      planningTechnicien.setAgency(
        userMail.value,
        userPassword.value,
        agencyId,
        function () {}
      );
    };

    const getAgency = function () {
      planningTechnicien.getAgency(userMail.value, userPassword.value, function (data) {
        if (data.code == 0 && data.data != "") {
          selectedAgency.value = data.data;
        }
      });
    };

    const getEventsListFiltered = computed(function () {
      if (eventsList.value.length == 0) return [];

      console.log("eventsList", eventsList.value);
      // let filteredData = [
      //   ...new Map(eventsList.value.map((item) => [item.CLD_NUM_CONTRAT, item])).values(),
      // ];

      let filteredData = eventsList.value.filter((val) =>
        [
          val["Technicien"]
            .filter((val) => val != null)
            .join(" - ")
            .toLowerCase(),
          val["N° RAP COMP"].toLowerCase(),
          val["adliv"].toLowerCase(),
          val["societeliv"].toLowerCase(),
          val["villeliv"].toLowerCase(),
        ]
          .join(" ")
          .includes(filter.value.toLowerCase())
      );
      if (selectedAgency.value)
        filteredData = filteredData.filter(
          (val) => val.ID_Agence == selectedAgency.value
        );
      if (showOnlyState2.value == true) {
        filteredData = filteredData.filter((val) => val.Statut == "120");
      }
      return filteredData;
    });

    watch(filter, (val) => {
      if (val[0] == " ") filter.value = filter.value.trim();
    });

    const getAllContratToShow = computed(function () {
      let livRemoveDoublon = [
        ...new Map(
          contratListeToShowLiv.value.map((item) => [item.CLD_NUM_CONTRAT, item])
        ).values(),
      ];
      let retRemoveDoublon = [
        ...new Map(
          contratListeToShowRet.value.map((item) => [item.CLD_NUM_CONTRAT, item])
        ).values(),
      ];

      // let allContrat = livRemoveDoublon.concat(retRemoveDoublon);
let allContrat ={ livRemoveDoublon, retRemoveDoublon }
      console.log("allContrat", allContrat);

      // return allContrat;

      return allContrat;
    });

    const {
      eventsList,
      calendarOptions,
      selectedEvent,
      isModalEventOpen,
      eventsCalendar,
      editEventFromCalendar,
      isDataLoaded,
      eventColorById,
      initEvents,
      calendarDate,
      refreshData,
      isConnected,
      selectedAgency,
      agencyList,
      technicienList,
      selectedTechniciens,
      technicienListAvailable,
      setTechnicienAvailable,
      isTechnicienAvailable,
      showErrorMessage,
      errorMessage,
      planningSettings,
      isRoot,
      updateCalendarColors,
      updateCalendarDaysToShow,
      daysToHide,
      isModalSettingsOpen,
      commentaireListe,
      setCommentaires,
      eventColorByIdFiltered,
      optionsPlanning,
      nbrDaysdurationListe,
      slotdurationListe,
      startPlanningTime,
      endPlanningTime,
      selectedNbrDays,
      selectedslotduration,
      selectedStartTime,
      selectedEndTime,
      updatePlanningVue,
      contratListe,
      contratListeToShow,
      contratListeToShowLiv,
      contratListeToShowRet,
      cancelDriver,
      // getAllContratToShow,
    } = calendarData(
      handleEventClick,
      handleEventDrop,
      handleEventDragTime,
      handleEventReceive,
      getTechToShow,
      setAgency,
      getAgency,
      fullView,
      props.windowSize,
      selectedSize
    );

    return {
      getEventsListFiltered,
      calendarOptions,
      selectedEvent,
      isModalEventOpen,
      editEventFromCalendar,
      eventsCalendar,
      errorMessage,
      isDataLoaded,
      eventColorById,
      filter,
      editEventFromModal,
      closeModalEvent,
      calendarDate,
      isModalTechnicienOpen,
      modaleTechnicienData,
      verifEditEventFromModal,
      refreshData,
      isConnected,
      userPassword,
      userMail,
      connectionError,
      eventsList,
      agencyList,
      selectedAgency,
      isRoot,
      technicienList,
      selectedTechniciens,
      addOrRmvTechnicien,
      isModalSelectionTechnicienOpen,
      setSelectedTechniciens,
      showOnlyState2,
      isModalChangeEventStateOpen,
      modaleChangeEventState,
      removeEventFromList,
      technicienListAvailable,
      setTechnicienAvailable,
      updateTechToShow,
      planningSettings,
      updateCalendarColors,
      updateCalendarDaysToShow,
      daysToHide,
      isModalSettingsOpen,
      isModalOptionOpen,
      commentaireListe,
      setCommentaires,
      fullView,
      showLegende,
      eventColorByIdFiltered,
      optionsPlanning,
      isDateSettingOpen,
      nbrDaysdurationListe,
      slotdurationListe,
      startPlanningTime,
      endPlanningTime,
      selectedNbrDays,
      selectedslotduration,
      selectedStartTime,
      selectedEndTime,
      updatePlanningVue,
      selectedSize,
      contratListe,
      contratListeToShow,
      contratListeToShowLiv,
      contratListeToShowRet,
      cancelDriver,
      getAllContratToShow,
    };
  },
  data() {
    return {
      // Vrai quand la souris est sur/près de la légende → on la masque (opacité 0)
      // pour dégager la vue. La légende reste "traversante" (pointer-events:none).
      legendHidden: false,
    };
  },
  mounted() {
    this._onLegendMouseMove = this.onLegendMouseMove.bind(this);
    window.addEventListener("mousemove", this._onLegendMouseMove);
  },
  beforeUnmount() {
    if (this._onLegendMouseMove)
      window.removeEventListener("mousemove", this._onLegendMouseMove);
  },
  watch: {
    selectedNbrDays() {
      this.updatePlanningVue();
    },
    selectedslotduration() {
      this.updatePlanningVue();
    },
    selectedStartTime() {
      this.updatePlanningVue();
    },
    selectedEndTime() {
      this.updatePlanningVue();
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.display.xs;
    },
  },
  methods: {
    // Masque la légende quand la souris est dessus ou proche (rayon = margin),
    // et la réaffiche dès qu'on s'en éloigne. getBoundingClientRect reste valide
    // même à opacité 0, donc la réapparition fonctionne.
    onLegendMouseMove(e) {
      const el = this.$refs.legendEl;
      if (!el) { this.legendHidden = false; return; }
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) { this.legendHidden = false; return; }
      const margin = 50; // zone de proximité (px)
      this.legendHidden =
        e.clientX >= r.left - margin && e.clientX <= r.right + margin &&
        e.clientY >= r.top - margin && e.clientY <= r.bottom + margin;
    },
    removeDoublon(array, field, keepLast = false) {
      const map = new Map();

      if (keepLast) {
        // garde le dernier doublon
        array.forEach((item) => {
          map.set(item[field], item);
        });
        return Array.from(map.values());
      }

      // garde le premier doublon
      array.forEach((item) => {
        if (!map.has(item[field])) {
          map.set(item[field], item);
        }
      });

      return Array.from(map.values());
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },

    closeSettingsModal(data) {
      let that = this;
      let days = data.daysListe.filter((val) => !data.daysToShow.includes(val.idx));
      if (days) {
        days = days.map((val) => val.idx);
        engine.save_day_to_hide(days.toString(), function () {
          that.updateCalendarDaysToShow();
        });
      }
      engine.save_calendar_colors(JSON.stringify(data.localColortab), function () {
        that.updateCalendarColors();
      });
      this.isModalSettingsOpen = false;
    },
    editSelectionnedTechnicien(data) {
      this.selectedTechniciens = data;
    },
    setSelectedEvent(elem) {
      this.selectedEvent = elem;
    },
  },
};
</script>

<style>
@import "../style.css";

.planning-technicien #external-events {
  float: left;
  /* margin: 10px; */
  /* height: 94.8vh; */
  color: black;
  background: #c8e6c9;
  border-radius: 3px;
  border: solid 1px #dcedc8 !important;
}

.planning-technicien #external-events .fc-event {
  cursor: move;
  /* margin: 3px 0; */
}

.planning-technicien #calendar-container {
  /* margin: 10px; */
  padding-top: 10px;
}

.planning-technicien #calendar {
  border: solid 1px lightgrey;
  border-radius: 3px;
  padding: 5px;
}

.planning-technicien .hideDot .fc-list-event-graphic {
  background: white;
  min-width: 0px;
  width: 0px;
  padding-left: 0px !important;
}

.planning-technicien .hideDot .fc-list-event-time {
  background: white;
}

.planning-technicien .hideDot .fc-list-event-title {
  background: white;
}
</style>
